import React, { createContext, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

const UtilsContext = createContext(null)
const { Provider } = UtilsContext

export const useUtils = () => useContext(UtilsContext)

export default function UtilsProvider({ children }) {
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(true)

  const providerValue = useMemo(() => ({
    sidebar: {
      isCollapsed: isSidebarCollapsed,
      setCollapsed: setSidebarCollapsed,
    },
  }), [isSidebarCollapsed])

  return (
    <Provider value={providerValue}>
      {children}
    </Provider>
  )
}

UtilsProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
